// extracted by mini-css-extract-plugin
export var bodyRow = "_g0-d";
export var cardColumns = "_g0-e";
export var ellipsesOverflow = "_g0-2";
export var flatBottomCorners = "_g0-3";
export var flatTopCorners = "_g0-4";
export var headerActionsDropdown = "_g0-f";
export var headerBottomRow = "_g0-c";
export var headerTopRow = "_g0-b";
export var orderDetailsWrapper = "_g0-0";
export var orderInfoContainer = "_g0-1";
export var productDetails = "_g0-9";
export var productImage = "_g0-5";
export var responsiveTable = "_g0-8";
export var shipmentContainer = "_g0-a";
export var tableBottomLeft = "_g0-6";
export var tableBottomRight = "_g0-7";